<tool-drawer-container [shouldShowToggleBtn]="false">
  <tool-header
    class="tool-header"
    headerTitle="FTIC Course DWF & APR"
    [pathBreadcrumbs]="
      toolListService.getHelpPagePathBreadcrumbs('ftic_course_external')
    "
  ></tool-header>

  <div class="tool-content-container main-content">
    <div class="tool-description">
      Below are the step by step instructions on how to use FTIC Course DWF &
      APR (External) Tool.
    </div>

    <div class="tool-div">
      <div class="left-align-div">
        <h1 class="h1-header">
          Admin Support (External)
          <i class="fa-solid fa-arrow-right"></i> FTIC Course DWF & APR
        </h1>

        <h3 class="h3-second-header">
          Initial results with default form values
        </h3>

        <ul class="unordered-list">
          <li>
            Once you get to the page, results will automatically generate based
            on the default values in the FTIC Course DWF & APR form fields.
          </li>
        </ul>
      </div>

      <div class="left-align-div">
        <h3 class="h3-second-header">Goal for FTIC Course DWF & APR tool</h3>

        <ul class="unordered-list">
          <li>
            Analyze the most frequently enrolled courses by selected programs
            and terms.
          </li>
          <li>
            The charts below the table displays course grades and trends of
            passing rates based on selected program and term.
          </li>
        </ul>
      </div>

      <div class="left-align-div">
        <h3 class="h3-second-header">FTIC Course DWF & APR Form Submission</h3>

        <ol class="ordered-list">
          <li>Select a program [Default: Cybersecurity]</li>
          <li>Select a cohort [Default: 2020]</li>
          <li>Select the range for high school GPA [Default: 0 - 5.04]</li>
          <li>Select a UWF Year [Default: UWFYear1]</li>
          <li>Select a term [Default: 202008]</li>
        </ol>
      </div>

      <div class="left-align-div">
        <p></p>
        <div>
          <img
            class="small-pics"
            [(src)]="env['logo_paths']['helpPageFTICCourseDWFAPRExternal42']"
            alt=""
          />
          <p class="picture-caption">
            Figure 42: Default inputs for FTIC Course DWF & APR form
          </p>
        </div>
      </div>

      <div class="left-align-div">
        <h3 class="h3-second-header">
          Additional FTIC Course DWF & APR Form Fields
        </h3>

        <ol class="ordered-list">
          <li>Select a course [Default: AFR1101]</li>
        </ol>
      </div>

      <div class="left-align-div">
        <p>
          <b
            >This form field is associated with the graphs below it which are
            Course Grades by APR and Trend of passing rates.</b
          >
        </p>
        <div>
          <img
            class="set-img-width-sm"
            [(src)]="env['logo_paths']['helpPageFTICCourseDWFAPRExternal43']"
            alt=""
          />
          <p class="picture-caption">
            Figure 43: FTIC Course DWF & APR additional form field
          </p>
        </div>
      </div>

      <div class="left-align-div">
        <h3 class="h3-second-header">Results after Form Submission</h3>

        <ul class="unordered-list">
          <li>
            After you change the form fields’ values to your desired values, the
            form will automatically submit itself.
          </li>
          <li>
            The results will be regenerated based on the new input values.
          </li>
          <div>
            <p></p>
            <img
              class="small-pics"
              [(src)]="env['logo_paths']['helpPageFTICCourseDWFAPRExternal44']"
              alt=""
            />
            <p class="picture-caption">
              Figure 44: FTIC Course DWF & APR Table Result
            </p>
          </div>
          <div>
            <p></p>
            <img
              class="small-pics"
              [(src)]="env['logo_paths']['helpPageFTICCourseDWFAPRExternal44a']"
              alt=""
            />
            <p class="picture-caption">
              Figure 44a: FTIC Course DWF & APR First and Second Graphs
            </p>
          </div>
        </ul>
      </div>
    </div>
  </div>

  <related-links
    class="right-sidenav"
    [links]="
      toolListService.getExternalAdminSupportRelatedLinkBasedOnTool(
        'FTIC Course DWF & APR',
        true
      )
    "
  ></related-links>
</tool-drawer-container>
